import React, { useState, useEffect, useRef, useContext } from 'react'
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Button,
  IconButton,
  Rating,
  Paper
} from "@mui/material";
import axios from 'axios'
import EditIcon from '@rsuite/icons/Edit'
import AddReview from './AddReview'

const CustomerReviewModal = (data) => {
  const [tableData, setTableData] = useState([])
  const [isEditReview, setIsEditReview] = useState(null)
  const url = process.env.REACT_APP_SERVER_URL
  const { Column, HeaderCell, Cell } = Table
  useEffect(() => {
    // viewReviewByPhone(data.data.phone)
    if (data.data.customerId) getReviewsByCustomerId(data.data.customerId)
    else getReviewsByTenantId(data.data.tenantId)
  }, [isEditReview])

  const closeModal = () => {
    data.data.setShowReview(false)
  }

  const getReviewsByCustomerId = async (customerId) => {
    try {
      await axios
        .get(`${url}/getReviewsByCustomerId/${customerId}`)
        .then((responseForReviews) => {
          setTableData(responseForReviews.data)
        })
    } catch (error) {
      console.log(error)
    }
  }

  const getReviewsByTenantId = async (tenantId) => {
    try {
      await axios
        .get(`${url}/getReviewsByTenantId/${tenantId}`)
        .then((responseForReviews) => {
          setTableData(responseForReviews.data)
        })
    } catch (error) {
      console.log(error)
    }
  }
  return (
    <Dialog
      open={data.data.showReview}
      onClose={closeModal}
      maxWidth="lg"
      fullWidth
      sx={{ zIndex: 2000 }}
    >
      <DialogTitle>Customer Review</DialogTitle>
      <DialogContent dividers>
        <TableContainer component={Paper}>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell align="center"><b>Overall Rating</b></TableCell>
                <TableCell align="center"><b>Comment</b></TableCell>
                <TableCell align="center"><b>Noisy</b></TableCell>
                <TableCell align="center"><b>Cleanliness</b></TableCell>
                <TableCell align="center"><b>Pay On Time</b></TableCell>
                <TableCell align="center"><b>Traffic</b></TableCell>
                <TableCell align="center"><b>Action</b></TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {tableData.map((row) => (
                <TableRow key={row.id}>
                  <TableCell align="center">
                    <Rating value={row.overallRating} readOnly />
                  </TableCell>
                  <TableCell align="center">{row.managerComments}</TableCell>
                  <TableCell align="center">
                    <Rating value={row.noisy} readOnly />
                  </TableCell>
                  <TableCell align="center">
                    <Rating value={row.cleanliness} readOnly />
                  </TableCell>
                  <TableCell align="center">
                    <Rating value={row.payOnTime} readOnly />
                  </TableCell>
                  <TableCell align="center">
                    <Rating value={row.traffic} readOnly />
                  </TableCell>
                  <TableCell align="center">
                    <IconButton
                      onClick={() => setIsEditReview(row.id)}
                      sx={{ padding: 0 }}
                    >
                      <EditIcon />
                    </IconButton>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </DialogContent>
      <DialogActions>
        <Button onClick={closeModal} variant="contained" color="primary">
          Back
        </Button>
      </DialogActions>
      {isEditReview !== null && <AddReview data={{ isEditReview, setIsEditReview }} />}
    </Dialog>

  )
}
export default CustomerReviewModal
